import { Link } from 'react-router-dom'
import { Seo } from '../components/Seo'

export function NotFoundPage() {
  return (
    <section className="not-found">
      <Seo title="Page Not Found" description="The requested page could not be found." path="/404" />
      <div className="container narrow"><span className="eyebrow">404 · Page not found</span><h1>This page is not part of the route.</h1><p>The address may have changed, or the link may be incomplete. Return home or explore the available services.</p><div className="hero-actions"><Link className="button" to="/">Return home</Link><Link className="button button-secondary" to="/services">View services</Link></div></div>
    </section>
  )
}
